import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.boundResize = () => this.resize()
    this.element.addEventListener('input', this.boundResize)

    // Initial resize
    this.resize()

    // Also resize after Turbo renders (for cached pages)
    this.turboRenderHandler = () => this.resize()
    document.addEventListener('turbo:render', this.turboRenderHandler)
  }

  disconnect() {
    this.element.removeEventListener('input', this.boundResize)
    document.removeEventListener('turbo:render', this.turboRenderHandler)
  }

  resize() {
    this.element.style.height = '0px'
    this.element.style.height = this.element.scrollHeight + 'px'
  }
}
